import { Component, OnInit } from '@angular/core';
import { GenericFilter } from '../model/filter/genericFilter.model';
import { ReportService } from '../services/report/report.service';
import { ToastrService } from 'ngx-toastr';
import {
  GroupingIndicatorsResult,
  TotalIndicators,
  TotalIndicatorsResult
} from '../model/configuration/groupingIndicatorsResult.model';
import { GroupingIndicators } from '../model/configuration/groupingIndicators.model';
import { BehaviorSubject, interval } from 'rxjs';
declare var jquery: any;
declare var $: any;

@Component({
  selector: 'indicators',
  templateUrl: './indicators.component.html',
  styleUrls: ['./indicators.component.css']
})
export class IndicatorsComponent implements OnInit {

  filterCollapse$: BehaviorSubject<boolean>;

  filter: GenericFilter;
  groupingIndicators: GroupingIndicators;
  totalIndicators: TotalIndicators;
  intervalUpdateSubscription;
  IntervalUpdate: number;
  SearchRecycle: boolean;
  name: string = 'Geral';

  constructor(private reportService: ReportService, private toastr: ToastrService) {
    this.SearchRecycle = false;
  }

  onAutomaticSearchChange() {

    if (this.IntervalUpdate == undefined) {
      return;
    }

    if (this.SearchRecycle) {
        this.intervalUpdateSubscription = interval(this.IntervalUpdate * 1000).subscribe(x => {
        this.receiveFilter(this.filter);
      });
    } else {

      this.intervalUpdateSubscription.unsubscribe();
    }
  }

  receiveFilter($event) {

    this.filter = $event;

    if (this.filter.BusinessProcess === undefined) {
      this.toastr.error('Necessario informar o processo de negócio'
        , 'Erro', { positionClass: 'toast-top-center' });
      return;
    }

    // if (!this.SearchRecycle){
      this.totalIndicators = new TotalIndicators();
      this.groupingIndicators = new GroupingIndicators();
    // }

    const indicatorFilter = this.translateFilterModel();

    if (this.filter.GroupingSplit) {
      this.getGroupingIndicators(indicatorFilter);
    } else {
      this.getTotalIndicators(indicatorFilter);
    }
  }

  getGroupingIndicators(indicatorFilter) {
    this.reportService.getGroupingIndicators(indicatorFilter)
      .subscribe((resp: GroupingIndicatorsResult) => {

        if (resp.result) {
          this.filterCollapse$.next(true);

          this.groupingIndicators = resp.result;
          console.log(this.groupingIndicators);

        } else if (resp.error) {

          this.toastr.error(resp.errorMessage, 'Erro', { positionClass: 'toast-top-center' });
        }
      });
  }

  getTotalIndicators(indicatorFilter) {
    this.reportService.getTotalIndicators(indicatorFilter)
      .subscribe((resp: TotalIndicatorsResult) => {

        if (resp.result) {
          this.filterCollapse$.next(true);
          this.totalIndicators = resp.result;
          console.log(this.totalIndicators);

        } else if (resp.error) {

          this.toastr.error(resp.errorMessage, 'Erro', { positionClass: 'toast-top-center' });
        }
      });
  }

  translateFilterModel() {
    return {
      businessProcessId: this.filter.BusinessProcess.id,
      stateId: this.filter.State.id,
      userId: this.filter.User !== undefined ? this.filter.User.id : undefined,
      dateFrom: this.filter.PeriodFrom,
      dateTo: this.filter.PeriodTo,
      groupingId: this.filter.Grouping != undefined ? this.filter.Grouping.id : undefined,
      considerWorkingDays: this.filter.CalulateType == 1
    };
  }

  ngOnInit() {

    this.groupingIndicators = new GroupingIndicators();
    this.totalIndicators = new TotalIndicators();
    this.filterCollapse$ = new BehaviorSubject(false);

    // $('.connectedSortable').sortable({
    //   placeholder: 'sort-highlight',
    //   connectWith: '.connectedSortable',
    //   handle: '.box-header, .nav-tabs',
    //   forcePlaceholderSize: true,
    //   zIndex: 999999
    // });
    //
    // $('.connectedSortable .box-header, .connectedSortable .nav-tabs-custom').css('cursor', 'move');
  }

}


